<div id="page-top">    
    <!-- Page Wrapper -->
    <div id="wrapper">   
        <app-sidebar></app-sidebar>
        <!-- Content Wrapper -->
        <div id="content-wrapper" class="d-flex flex-column">
            <!-- Main Content -->
            <div id="content">    
                <!-- Topbar -->
                <app-topbar></app-topbar>
                <!-- End of Topbar -->

                <!-- Begin Page Content -->
                <div class="container-fluid" >

                    <router-outlet></router-outlet>
       
                </div>
                <!-- /.container-fluid -->    
            </div>
            <!-- End of Main Content -->    
            <!-- Footer -->
            <app-footer></app-footer>
            <!-- End of Footer -->    
        </div>
        <!-- End of Content Wrapper -->    
    </div>
    <!-- End of Page Wrapper -->       
</div>